import React, { useState, useEffect, useCallback, useMemo } from 'react'
import { Modal } from 'react-bootstrap'
import { Link, useNavigate, useParams } from 'react-router-dom'
import Navbar from '../../components/navbar/navbar.jsx'
import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'
import { CustomButton } from '../../components/CustomButton/index.jsx'
import api from '../../services/api.js'
import AutocompleteProdutoMatch from '../../components/auto-complete-match-produto/complete-match.jsx'
import AutocompleteClienteNode from '../../components/autocomplete-cliente/autocomplete-clientenode.jsx'
import apinode from '../../services/apinode.js'
import swal from 'sweetalert'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage.js'
import { toast } from 'react-toastify'
import { ShareFill } from 'react-bootstrap-icons'
import { CustomPriceInput } from '../../components/CustomPriceInput/index.jsx'
import { adaptValue } from '../../utils/adaptValue.js'
import OrcamentosService from '../../services/database/OrcamentosService/index.js'
import ModalIncluirCliente from './ModalIncluirCliente.jsx'
import { useCommand } from '../../hooks/useCommand/index.js'
import reportOrcNoWMS from './reportOrcNoWMS.jsx'

// ─── helpers de módulo (estáveis) ─────────────────────────────────────────────
const norm = (s) => s?.trim().toUpperCase()

const ICONE_GRUPO = {
  SALA: 'bi-sofa', QUARTO: 'bi-moon', COZINHA: 'bi-cup-hot',
  BANHEIRO: 'bi-droplet', VARANDA: 'bi-flower1', ESCRITORIO: 'bi-briefcase',
  GARAGEM: 'bi-car-front', LAVANDERIA: 'bi-basket', CORREDOR: 'bi-signpost',
  SUITE: 'bi-moon-stars', AREA: 'bi-tree',
}
const iconeGrupo = (nome = '') =>
  ICONE_GRUPO[
    nome.trim().toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  ] || 'bi-house-door'

const agruparProdutos = (lista) => {
  const ordemGrupos = []
  const mapa = {}
  lista.forEach((p) => {
    const g = p.grupo_item?.trim().toUpperCase() || '__SEM_GRUPO__'
    if (!mapa[g]) {
      mapa[g] = []
      ordemGrupos.push(g)
    }
    mapa[g].push(p)
  })
  return ordemGrupos.flatMap((g) => mapa[g])
}

// ─── estilos compartilhados ───────────────────────────────────────────────────
const thStyle = {
  padding: '10px 10px', fontWeight: 700, color: '#6B7280',
  fontSize: 11, textTransform: 'uppercase', letterSpacing: '.4px',
  whiteSpace: 'nowrap', border: 'none',
}
const tdStyle = { padding: '8px 10px', verticalAlign: 'middle', border: 'none' }
const btnGrupoStyle = {
  padding: '2px 8px', fontSize: 11, background: 'none',
  border: '1px solid #C7D2FE', color: '#4F46E5', borderRadius: 6, cursor: 'pointer',
}

const IMG_BASE = process.env.REACT_APP_BACKEND_API

// ══════════════════════════════════════════════════════════════════════════════
// LINHA DO PRODUTO (memoizada) — só re-renderiza quando ESTA linha muda
// ══════════════════════════════════════════════════════════════════════════════
const LinhaProdutoBloco = React.memo(function LinhaProdutoBloco({
  produto, index, isAdmin, estaBuscando,
  isNewGroup, isLastInGroup, ehUltimaLinha,
  qtdGrupo, subtotalGrupo, isDeleting, isNovo, onFocado,
  onQtd, onVlUnit, onCusto, onDesconto, onObs,
  onProdId, onProdNome, onProdNomeInput, onProdInterno,
  onImg, onComissao, onExcluir, onEditarGrupo,
  onMoverCima, onMoverBaixo,
}) {
  const linhaRef = React.useRef(null)
  const jaFocou = React.useRef(false)
  const [flash, setFlash] = React.useState(false)

  // ao inserir um item novo: pisca a linha, rola até ela e foca o campo de produto
  React.useEffect(() => {
    if (isNovo && !jaFocou.current && linhaRef.current) {
      jaFocou.current = true
      setFlash(true)
      // espera o modal fechar antes de rolar (senão o modal devolve o scroll)
      setTimeout(() => {
        linhaRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' })
        const alvo = linhaRef.current?.querySelector('input[type="text"]')
        alvo?.focus({ preventScroll: true }) // preventScroll: foco não rouba o scroll
      }, 180)
      setTimeout(() => setFlash(false), 2400)
      onFocado?.()
    }
  }, [isNovo, onFocado])

  const imgSrc = produto.image
    ? produto.image.includes('node.ziphub.com.br')
      ? produto.image
      : `${IMG_BASE}/imagens/${produto.image}`
    : `${IMG_BASE}/imagens/no-image.jpg`

  return (
    <React.Fragment>
      {/* Cabeçalho do grupo */}
      {isNewGroup && produto.grupo_item && (
        <tr style={{ background: '#EEF2FF', borderTop: '1px solid #C7D2FE' }}>
          <td colSpan={isAdmin ? 10 : 8} style={{ padding: '7px 14px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <div style={{ width: 26, height: 26, borderRadius: 7, background: '#4F46E5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <i className={`bi ${iconeGrupo(produto.grupo_item)}`} style={{ fontSize: 12, color: '#fff' }}></i>
                </div>
                <span style={{ fontWeight: 700, fontSize: 12, color: '#3730A3' }}>
                  {produto.grupo_item.toUpperCase()}
                </span>
                <span style={{ fontSize: 11, color: '#6366F1', background: '#E0E7FF', padding: '1px 8px', borderRadius: 20 }}>
                  {qtdGrupo} item(s)
                </span>
              </div>
              <div style={{ display: 'flex', gap: 4 }}>
                <button type="button" onClick={() => onMoverCima(produto.grupo_item)} style={btnGrupoStyle} disabled={index === 0}>
                  <i className="bi bi-arrow-up"></i>
                </button>
                <button type="button" onClick={() => onMoverBaixo(produto.grupo_item)} style={btnGrupoStyle} disabled={isLastInGroup && ehUltimaLinha}>
                  <i className="bi bi-arrow-down"></i>
                </button>
              </div>
            </div>
          </td>
        </tr>
      )}

      {/* Linha do produto */}
      <tr
        ref={linhaRef}
        className={flash ? 'linha-nova-flash' : undefined}
        style={{ borderBottom: isLastInGroup && produto.grupo_item ? '2px solid #E5E7EB' : '1px solid #F3F4F6', background: '#fff' }}
      >

        {/* SKU */}
        <td style={tdStyle}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <div style={{ position: 'relative', flexShrink: 0 }}>
              <img src={imgSrc} style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 8, border: '1px solid #E5E7EB' }} alt="" />
              <button
                type="button"
                onClick={() => onEditarGrupo(index, produto.grupo_item || '')}
                style={{ position: 'absolute', top: -5, left: -5, width: 18, height: 18, borderRadius: '50%', background: '#4F46E5', border: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}
                title="Editar grupo"
              >
                <i className="bi bi-pencil-fill" style={{ fontSize: 8, color: '#fff' }}></i>
              </button>
            </div>
            <span style={{ fontSize: 10, color: '#6B7280', fontFamily: 'monospace', background: '#F3F4F6', padding: '2px 5px', borderRadius: 4 }}>
              {produto.codigo || '—'}
            </span>
          </div>
        </td>

        {/* Produto */}
        <td style={tdStyle}>
          {estaBuscando ? (
            <AutocompleteProdutoMatch
              placeholder="Buscar produto..."
              onClickId={(id) => onProdId(index, id)}
              onClickNome={(nome) => onProdNome(index, nome)}
              onClickProdInterno={(p) => onProdInterno(index, p)}
              OnClickValor={(v) => onVlUnit(index, v)}
              OnClickCusto={(c) => onCusto(index, c)}
              OnClickImg={(i) => onImg(index, i)}
              OnClickComissaoProduto={(v) => onComissao(index, v)}
              ClickTexto={() => {}}
              value={produto.descricao}
              className="form-control form-control-sm"
            />
          ) : (
            <input
              type="text"
              placeholder="Inserir manualmente..."
              className="form-control form-control-sm"
              value={produto.descricao}
              onChange={(e) => onProdNomeInput(index, e.target.value)}
            />
          )}
        </td>

        {/* Qtd */}
        <td style={tdStyle}>
          <input
            type="text"
            className="form-control form-control-sm text-center"
            style={{ fontWeight: 700 }}
            onChange={(e) => onQtd(index, e.target.value.replace(',', '.'))}
            value={produto?.quantidade !== undefined ? produto.quantidade.toString() : ''}
          />
        </td>

        {/* Custo unit (admin) */}
        {isAdmin && (
          <td style={tdStyle}>
            <div className="input-group input-group-sm">
              <span className="input-group-text" style={{ fontSize: 10 }}>R$</span>
              <input
                type="text" className="form-control text-end" style={{ fontSize: 11 }}
                onChange={(e) => onCusto(index, e.target.value.replace(',', '.'))}
                value={produto.preco_custo !== undefined ? produto.preco_custo?.toLocaleString(undefined, { minimumFractionDigits: 2 }) : ''}
              />
            </div>
          </td>
        )}

        {/* Valor unit */}
        <td style={tdStyle}>
          <div className="input-group input-group-sm">
            <span className="input-group-text" style={{ fontSize: 10, background: '#EEF2FF', color: '#4F46E5', border: '1px solid #C7D2FE' }}>R$</span>
            <input
              type="text" className="form-control text-end fw-bold" style={{ fontSize: 11 }}
              onChange={(e) => onVlUnit(index, e.target.value.replace(',', '.'))}
              value={produto.valorunitario !== undefined ? produto.valorunitario.toLocaleString(undefined, { minimumFractionDigits: 2 }) : ''}
            />
          </div>
        </td>

        {/* Desconto */}
        <td style={tdStyle}>
          <div className="input-group input-group-sm">
            <CustomPriceInput
              value={produto.desconto}
              onChange={(e) => onDesconto(index, e.target.value.replace(',', '.'))}
              className="form-control text-end" style={{ fontSize: 11 }}
            />
            <span className="input-group-text" style={{ fontSize: 10 }}>R$</span>
          </div>
        </td>

        {/* Total custo (admin) */}
        {isAdmin && (
          <td style={tdStyle}>
            <div className="input-group input-group-sm">
              <span className="input-group-text" style={{ fontSize: 10 }}>R$</span>
              <input
                type="text" className="form-control text-end" disabled style={{ fontSize: 11, background: '#F9FAFB' }}
                value={produto.total_custo !== undefined ? produto.total_custo?.toLocaleString(undefined, { minimumFractionDigits: 2 }) : ''}
              />
            </div>
          </td>
        )}

        {/* Total */}
        <td style={tdStyle}>
          <div className="input-group input-group-sm">
            <span className="input-group-text" style={{ fontSize: 10, background: '#F0FDF4', color: '#16A34A', border: '1px solid #BBF7D0' }}>R$</span>
            <CustomPriceInput
              disabled value={produto.valor_total_item}
              className="form-control text-end fw-bold" style={{ fontSize: 11, background: '#F9FAFB' }}
            />
          </div>
        </td>

        {/* Obs */}
        <td style={tdStyle}>
          <textarea
            value={produto.obs} className="form-control form-control-sm"
            onChange={(e) => onObs(index, e.target.value)}
            style={{ fontSize: 10, minHeight: 36, resize: 'none' }}
            placeholder="Obs..." rows={1}
          />
        </td>

        {/* Excluir */}
        <td style={{ ...tdStyle, textAlign: 'center' }}>
          <CustomButton
            type="button"
            isLoading={isDeleting}
            color="#DC2626"
            onClick={() => onExcluir(produto, index)}
            style={{ padding: '4px 8px', background: 'none', border: '1px solid #FCA5A5', color: '#DC2626', borderRadius: 6, fontSize: 12 }}
          >
            <i className="bi bi-trash3"></i>
          </CustomButton>
        </td>
      </tr>

      {/* Subtotal do grupo */}
      {isLastInGroup && produto.grupo_item && (
        <tr style={{ background: '#F9FAFB', borderBottom: '1px solid #E5E7EB' }}>
          <td colSpan={isAdmin ? 7 : 5} style={{ padding: '6px 14px', textAlign: 'right', fontSize: 11, color: '#6B7280', fontWeight: 600 }}>
            Subtotal {produto.grupo_item.toUpperCase()}
          </td>
          <td style={{ padding: '6px 8px', textAlign: 'right' }}>
            <span style={{ fontSize: 12, fontWeight: 700, color: '#16A34A', background: '#DCFCE7', padding: '3px 12px', borderRadius: 20 }}>
              {subtotalGrupo.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
            </span>
          </td>
          <td colSpan={2}></td>
        </tr>
      )}
    </React.Fragment>
  )
})

function OrcamentoEditar() {
  const { id_pedido, conta, print } = useParams()

  // ─── estados ──────────────────────────────────────────────────────────────
  const [clienteSemCada, setSemCad]           = useState('')
  const [estaBuscando, setEstaBuscando]       = useState(true)
  const [dt_pedido, setDtPedido]              = useState('')
  const [produtos, setProdutos]               = useState([])
  const [vl_total, setVlTotal]                = useState(0)
  const [desconto, setDesconto]               = useState(0)
  const [vendedor, setVendedor]               = useState('')
  const [prestador, setPrestador]             = useState('')
  const [indicacaoVenda, setIndicacaoVenda]   = useState('')
  const [id_cliente, setIdCliente]            = useState('')
  const [nomeCliente, setNomeCliente]         = useState('')
  const [cpf, setCpf]                         = useState('')
  const [dadospedido, setDadosPedido]         = useState({})
  const [vendedores, setVendedores]           = useState([])
  const [parceiros, setParceiros]             = useState([])
  const [prestadores, setPrestadores]         = useState([])
  const [parceiro, setParceiro]               = useState('')
  const [detalhesPedido, setDetalhesPedido]   = useState('')
  const [descontoItem, setDescontoItem]       = useState([])
  const [dadosEmp, setDadosEmp]               = useState([])
  const [totalCusto, setTotalCusto]           = useState(0)
  const [loading, setLoading]                 = useState(false)
  const [grupoItem, setGrupoItem]             = useState('')
  const [itemSelecionado, setItemSelecionado] = useState(null)
  const [inputValue, setInputValue]           = useState('')
  const [novoItemId, setNovoItemId]           = useState(null)
  const [clientes, setClientes]               = useState([])
  const [isDeleteProductLoading, setIsDeleteProductLoading] = useState({})
  const [isExportSaleLoading, setIsExportSaleLoading]       = useState(false)
  const [showModalCliente, setShowModalCliente] = useState(false)

  // grupos
  const [gruposExistentes, setGruposExistentes] = useState([])
  const [showGrupoModal, setShowGrupoModal]     = useState(false)
  const [grupoSelecionado, setGrupoSelecionado] = useState('')
  const [novoGrupoInput, setNovoGrupoInput]     = useState('')

  const navigate = useNavigate()

  // ─── carrega grupos do banco ──────────────────────────────────────────────
  const carregarGrupos = useCallback(async () => {
    try {
      const res = await apinode.get(`/grupos/${conta}/${id_pedido}`)
      setGruposExistentes(res.data)
    } catch (e) { console.error(e) }
  }, [conta, id_pedido])

  // ─── sincroniza grupos dos produtos com gruposExistentes ──────────────────
  // guarda de igualdade: só atualiza se realmente mudou (evita renders extras)
  useEffect(() => {
    if (produtos.length === 0) return
    const gruposDoPedido = [
      ...new Set(produtos.map((p) => norm(p.grupo_item)).filter(Boolean)),
    ]
    setGruposExistentes((prev) => {
      const merged = [...new Set([...prev, ...gruposDoPedido])].sort()
      if (merged.length === prev.length && merged.every((g, i) => g === prev[i])) {
        return prev // sem mudança → mantém referência, não re-renderiza
      }
      return merged
    })
  }, [produtos])

  const salvarGrupoBanco = async (nome) => {
    if (!nome || gruposExistentes.includes(nome)) return
    try {
      await apinode.post(`/grupos/${conta}/${id_pedido}`, { nome })
      setGruposExistentes((prev) => [...new Set([...prev, nome])].sort())
    } catch (e) { console.error(e) }
  }

  // ─── adicionar produto ────────────────────────────────────────────────────
  function AdicionarProduto() {
    setGrupoSelecionado('')
    setNovoGrupoInput('')
    setShowGrupoModal(true)
  }

  async function confirmarAdicionarProduto() {
    const grupo = novoGrupoInput.trim().toUpperCase() || grupoSelecionado

    // não bloqueia a UI — se o cadastro do grupo falhar, apenas loga
    salvarGrupoBanco(grupo).catch((e) => console.error('grupo:', e))

    const novoProd = {
      id: uuidv4(), codigo: 0, descricao: '', quantidade: '1',
      quantidade_nova: 1, valorunitario: 0, valor_total_item: 0,
      desconto: 0, preco_custo: 0, image: 'no-image.jpg',
      grupo_item: grupo || null, new: true,
    }

    setNovoItemId(novoProd.id) // marca para rolar/focar ao renderizar

    setProdutos((prev) => {
      if (!grupo) return [...prev, novoProd]

      const alvo = norm(grupo)
      // encontra o último índice do grupo (comparação normalizada nos DOIS lados)
      const lastIdx = prev.reduce(
        (acc, p, idx) => (norm(p.grupo_item) === alvo ? idx : acc), -1,
      )

      if (lastIdx === -1) return [...prev, novoProd]

      const arr = [...prev]
      arr.splice(lastIdx + 1, 0, novoProd)
      return arr
    })

    setShowGrupoModal(false)
  }

  // ─── editar grupo do item ─────────────────────────────────────────────────
  const handleInserir = async () => {
    if (itemSelecionado === null || inputValue.trim() === '') return
    const novoGrupo = inputValue.trim().toUpperCase()
    await salvarGrupoBanco(novoGrupo)

    setProdutos((prev) => {
      const arr = [...prev]
      arr[itemSelecionado] = { ...arr[itemSelecionado], grupo_item: novoGrupo }
      return agruparProdutos(arr)
    })

    setItemSelecionado(null)
    setInputValue('')
  }

  const handleInputChange = (e) => {
    setInputValue(e.target.value)
  }

  // ─── cálculos ─────────────────────────────────────────────────────────────
  const calcularTotalCusto = () =>
    produtos.reduce((t, p) => t + (p.total_custo || 0), 0)

  function CalculaTotal() {
    setVlTotal(produtos.reduce((t, p) => t + (p.valor_total_item || 0), 0))
  }

  // ─── mover grupos (funcional + estável) ───────────────────────────────────
  const moverGrupoParaCima = useCallback((grupo) => {
    setProdutos((prev) => {
      const idx = prev.findIndex((p) => norm(p.grupo_item) === norm(grupo))
      if (idx <= 0) return prev
      const atual    = prev.filter((p) => norm(p.grupo_item) === norm(grupo))
      const anterior = prev.filter((p) => norm(p.grupo_item) === norm(prev[idx - 1]?.grupo_item))
      const lista = prev.filter(
        (p) => norm(p.grupo_item) !== norm(grupo) && norm(p.grupo_item) !== norm(prev[idx - 1]?.grupo_item),
      )
      lista.splice(idx - anterior.length, 0, ...atual, ...anterior)
      return lista
    })
  }, [])

  const moverGrupoParaBaixo = useCallback((grupo) => {
    setProdutos((prev) => {
      const idx = prev.findIndex((p) => norm(p.grupo_item) === norm(grupo))
      if (idx >= prev.length - 1) return prev
      const atual   = prev.filter((p) => norm(p.grupo_item) === norm(grupo))
      const proximo = prev.filter((p) => norm(p.grupo_item) === norm(prev[idx + atual.length]?.grupo_item))
      const lista = prev.filter(
        (p) => norm(p.grupo_item) !== norm(grupo) && norm(p.grupo_item) !== norm(prev[idx + atual.length]?.grupo_item),
      )
      lista.splice(idx + proximo.length, 0, ...proximo, ...atual)
      return lista
    })
  }, [])

  // ─── pdf ──────────────────────────────────────────────────────────────────
  async function handleExportSale(idOrcamento) {
    if (produtos.length === 0) return toast.warn('Adicione ao menos 1 produto!')
    try {
      setIsExportSaleLoading(true)
      const msg = await OrcamentosService.exportToSales(idOrcamento)
      toast.success(msg)
      navigate('/orcamentos')
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao exportar a venda!')
    } finally {
      setIsExportSaleLoading(false)
    }
  }

  async function ImpPdf(tipo) {
    const sel          = document.getElementById('parceiroSelect')
    const parceiroNome = sel?.selectedOptions[0]?.text || ''
    const dados_pedido = {
      numeroorc: id_pedido, cliente: nomeCliente, id_cliente: id_cliente || 0,
      id_pagamento: null, cod_vendedor: vendedor || null,
      data: dt_pedido || moment().format('YYYY-MM-DD'), valor: vl_total,
      desconto: descontoItem || null, desconto_din: desconto || 0,
      id_parceiro: indicacaoVenda || null, cpf,
      detalhes_pedido: detalhesPedido || 'Não informado',
      itens: produtos, empresa: dadosEmp, dadosDoCliente: clientes,
      Parceiro: parceiroNome,
    }

    async function toBase64(url) {
      return new Promise((res, rej) => {
        const img = new Image()
        img.setAttribute('crossOrigin', 'anonymous')
        img.onload = () => {
          const c = document.createElement('canvas')
          c.width = img.width
          c.height = img.height
          c.getContext('2d').drawImage(img, 0, 0)
          res(c.toDataURL('image/jpeg'))
        }
        img.onerror = rej
        img.src = url
      })
    }

    for (const item of dados_pedido.itens) {
      const url = item.image
        ? item.image.includes('node.ziphub.com.br')
          ? item.image
          : `https://node.ziphub.com.br/imagens/${item.image}`
        : 'https://node.ziphub.com.br/imagens/no-image.jpg'
      try {
        item.base64 = await toBase64(url)
      } catch {
        try {
          item.base64 = await toBase64('https://node.ziphub.com.br/imagens/no-image.jpg')
        } catch {
          item.base64 = ''
        }
      }
    }
    reportOrcNoWMS(dados_pedido, tipo)
  }

  // ─── token ────────────────────────────────────────────────────────────────
  const reqToken = async (c) => {
    try {
      const r = await api.get('/emp', { params: { token: c } })
      if (r.status === 200) {
        const token = r.data?.ID_CONTA
        if (!token)
          swal('Sessão expirada', 'Por favor, feche e abra novamente.', 'warning')
        else {
          setDadosEmp([r.data])
          localStorage.setItem('id_conta', token)
        }
      }
    } catch {
      swal('Erro na requisição', 'Ocorreu um erro ao buscar o token.', 'error')
    }
  }

  // ─── desconto total proporcional ──────────────────────────────────────────
  const handleDescontoTotal = (value) => {
    const d = adaptValue(value)
    if (isNaN(d) || d <= 0) {
      setDesconto(null)
      setProdutos((prev) =>
        prev.map((p) => ({
          ...p,
          desconto: 0,
          valor_total_item: p?.quantidade * p.valorunitario,
        })),
      )
      return
    }
    const total = produtos.reduce((a, p) => a + (p.valor_total_item || 0), 0)
    const prop  = total > 0 ? d / total : 0
    setDesconto(d)
    setProdutos(
      produtos.map((p) => {
        if (!isNaN(p?.quantidade) && !isNaN(p.valorunitario)) {
          const vDesc = prop * (p.valor_total_item || 0)
          return {
            ...p,
            desconto: vDesc,
            valor_total_item: parseFloat(p?.quantidade * p.valorunitario - vDesc),
          }
        }
        return p
      }),
    )
  }

  // ─── handlers de campo (do cabeçalho, não da tabela) ──────────────────────
  const handleIdCliente   = (id)   => setIdCliente(id)
  const handleCpf         = (c)    => setCpf(c)
  const handleNomeCliente = (nome) => {
    setNomeCliente(nome)
    setDadosPedido((p) => ({ ...p, cliente: nome }))
  }

  // ══════════════════════════════════════════════════════════════════════════
  // HANDLERS DA LINHA — estáveis (useCallback []) e IMUTÁVEIS (criam obj novo)
  // ══════════════════════════════════════════════════════════════════════════
  const onQtd = useCallback((i, qtd) => {
    setProdutos((prev) => {
      const a = [...prev]
      a[i] = {
        ...a[i],
        quantidade: qtd,
        valor_total_item: qtd * a[i].valorunitario,
        total_custo: qtd * a[i].preco_custo,
      }
      return a
    })
  }, [])

  const onVlUnit = useCallback((i, vl) => {
    setProdutos((prev) => {
      const a = [...prev]
      const vtotal = a[i].quantidade * vl
      a[i] = {
        ...a[i],
        valorunitario: vl,
        valor_total_item: vtotal,
        valor_novo: isNaN(vtotal) ? 0 : vtotal,
      }
      return a
    })
  }, [])

  const onCusto = useCallback((i, vl) => {
    setProdutos((prev) => {
      const a = [...prev]
      const preco = vl || 0
      a[i] = {
        ...a[i],
        preco_custo: preco,
        total_custo: isNaN(preco) ? 0 : a[i].quantidade * preco,
      }
      return a
    })
  }, [])

  const onDesconto = useCallback((i, value) => {
    setProdutos((prev) => {
      const a = [...prev]
      const p = a[i]
      const vti =
        !isNaN(p?.quantidade) && !isNaN(p.valorunitario) && !isNaN(value)
          ? p.quantidade * p.valorunitario - value
          : 0
      a[i] = { ...p, valor_total_item: vti, desconto: value }
      return a
    })
  }, [])

  const onObs = useCallback((i, value) => {
    setProdutos((prev) => { const a = [...prev]; a[i] = { ...a[i], obs: value }; return a })
  }, [])

  const onProdId = useCallback((i, id) => {
    setProdutos((prev) => { const a = [...prev]; a[i] = { ...a[i], codigo: id }; return a })
  }, [])

  const onProdNome = useCallback((i, nome) => {
    setProdutos((prev) => { const a = [...prev]; a[i] = { ...a[i], descricao: nome }; return a })
  }, [])

  const onProdNomeInput = useCallback((i, nome) => {
    setProdutos((prev) => { const a = [...prev]; a[i] = { ...a[i], descricao: nome, codigo: '999999' }; return a })
  }, [])

  const onProdInterno = useCallback(() => {}, [])

  const onImg = useCallback((i, v) => {
    setProdutos((prev) => { const a = [...prev]; a[i] = { ...a[i], image: v || 'no-image.jpg' }; return a })
  }, [])

  const onComissao = useCallback((i, v) => {
    setProdutos((prev) => { const a = [...prev]; a[i] = { ...a[i], comissao_sobre_produto: v }; return a })
  }, [])

  const onEditarGrupo = useCallback((i, grupoAtual) => {
    setItemSelecionado(i)
    setInputValue(grupoAtual || '')
  }, [])

  const limparNovoItem = useCallback(() => setNovoItemId(null), [])

  // ─── busca pedido ──────────────────────────────────────────────────────────
  const buscapedido = useCallback(
    async (idpedido, willLoad = true) => {
      willLoad && setLoading(true)
      try {
        const r = await apinode.get(`/getorcamentos/${idpedido}/${conta}`)
        setProdutos(
          agruparProdutos(r.data.itens.map((item) => ({ ...item, new: false }))),
        )
        setDadosPedido(r.data)
        setClientes(r.data.clientes[0])
        const {
          cliente, data, cod_vendedor, id_parceiro, id_prestador,
          cpf, id_cliente, desconto_din, detalhes_pedido,
        } = r.data
        setDtPedido(moment(data).format('YYYY-MM-DD'))
        setNomeCliente(cliente)
        setVendedor(cod_vendedor)
        setIndicacaoVenda(id_parceiro)
        setParceiro(id_parceiro)
        setPrestador(id_prestador)
        setIdCliente(id_cliente)
        setCpf(cpf)
        setDetalhesPedido(detalhes_pedido)
        setDesconto(parseFloat(desconto_din))
      } catch (err) {
        console.error(err)
      } finally {
        willLoad && setLoading(false)
      }
    },
    [conta],
  )

  // ─── excluir produto (estável) ─────────────────────────────────────────────
  const onExcluir = useCallback(async (produto, index) => {
    if (produto.new) {
      setProdutos((p) => p.filter((_, i) => i !== index))
      return
    }
    try {
      setIsDeleteProductLoading((p) => ({ ...p, [index]: true }))
      await apinode.delete(
        `/orcamentos/products/${produto.id}/${id_pedido}/${localStorage.idconta}`,
      )
      toast.success('Produto removido!')
      buscapedido(id_pedido)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível excluir o produto!')
    } finally {
      setIsDeleteProductLoading((p) => ({ ...p, [index]: false }))
    }
  }, [id_pedido, buscapedido])

  // ─── salvar ───────────────────────────────────────────────────────────────
  async function SalvarDados() {
    if (!nomeCliente) {
      swal('Atenção', 'O campo cliente é obrigatório.', 'warning')
      return
    }
    if (produtos.length === 0 || produtos.some((p) => p.descricao.trim() === '')) {
      swal('Atenção', 'Adicione ao menos um produto com descrição preenchida.', 'warning')
      return
    }

    const produtosFormatted = produtos.map((p) => ({
      ...p,
      quantidade:    adaptValue(p.quantidade),
      porc_comissao: p.comissao_sobre_produto,
      total_comissao:
        adaptValue(p.valor_total_item) *
        (adaptValue(p.comissao_sobre_produto) / 100),
    }))

    const dados = {
      cliente:         nomeCliente,
      id_cliente:      id_cliente || 0,
      id_pagamento:    null,
      cod_vendedor:    vendedor || null,
      data:            dt_pedido || moment().format('YYYY-MM-DD'),
      valor:           vl_total,
      desconto:        desconto || null,
      desconto_din:    desconto || 0,
      id_parceiro:     indicacaoVenda || null,
      id_prestador:    prestador || null,
      cpf,
      detalhes_pedido: detalhesPedido || 'Não informado',
      grupo_item:      grupoItem || null,
      itens:           produtosFormatted,
    }

    try {
      setLoading(true)
      const r = await apinode.put(`/vendedores/updateorc/${conta}/${id_pedido}`, dados)
      swal('Sucesso', r.data.message, 'success')
      buscapedido(id_pedido)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível salvar o orçamento!')
    } finally {
      setLoading(false)
    }
  }

  // ─── misc ─────────────────────────────────────────────────────────────────
  const alternarModoBusca = () => setEstaBuscando((p) => !p)
  const pressF2 = useCallback(() => setEstaBuscando((p) => !p), [])
  useCommand(pressF2, ['F2'])

  // ─── effects ──────────────────────────────────────────────────────────────
  useEffect(() => { setTotalCusto(calcularTotalCusto()) }, [produtos])

  useEffect(() => {
    reqToken(conta)
    localStorage.setItem('id_conta', conta)
    buscapedido(id_pedido)
    carregarGrupos()
  }, [buscapedido, conta, id_pedido, carregarGrupos])

  useEffect(() => {
    CalculaTotal()
    if (print === 'print') ImpPdf('Completo')
  }, [produtos])

  useEffect(() => {
    apinode.get(`vendedores/prestador?conta=${conta}`).then((r) => setPrestadores(r.data)).catch(console.error)
    apinode.get(`vendedores/vendedor?conta=${conta}`).then((r) => setVendedores(r.data)).catch(console.error)
    apinode.get(`vendedores/parceiros?conta=${conta}`).then((r) => setParceiros(r.data)).catch(console.error)
  }, [])

  // ─── derivados / memoizados ────────────────────────────────────────────────
  const parceirosOrdenados = useMemo(
    () =>
      [...parceiros].sort((a, b) =>
        a.PES_RAZAO.toLowerCase().localeCompare(b.PES_RAZAO.toLowerCase()),
      ),
    [parceiros],
  )

  // subtotais e contagens por grupo — calculados UMA vez por render (O(n))
  const { subtotaisPorGrupo, contagemPorGrupo } = useMemo(() => {
    const sub = {}
    const cont = {}
    produtos.forEach((p) => {
      const g = norm(p.grupo_item) || '__SEM__'
      sub[g] = (sub[g] || 0) + (p.valor_total_item || 0)
      cont[g] = (cont[g] || 0) + 1
    })
    return { subtotaisPorGrupo: sub, contagemPorGrupo: cont }
  }, [produtos])

  const totalGeral    = produtos.reduce((t, p) => t + (p.valor_total_item || 0), 0)
  const totalCustoAll = produtos.reduce((t, p) => t + (p.total_custo || 0), 0)
  const totalQtd      = produtos.reduce((t, p) => t + Number(p.quantidade || 0), 0)
  const margem =
    totalGeral > 0
      ? (((totalGeral - totalCustoAll) / totalGeral) * 100).toFixed(1)
      : '0.0'
  const isAdmin      = localStorage.admin === 'SIM'
  const grupoPreview = novoGrupoInput.trim().toUpperCase() || grupoSelecionado
  const ultimoIndice = produtos.length - 1

  // ─── render ───────────────────────────────────────────────────────────────
  return (
    <>
      <Navbar />

      <div style={{ background: '#f4f6f9', minHeight: '100vh', paddingBottom: 48 }}>

        <style>{`
          @keyframes flashNovaLinha {
            0%, 100% { background-color: #ffffff; }
            25%      { background-color: #FEF9C3; }
            50%      { background-color: #FDE047; }
            75%      { background-color: #FEF9C3; }
          }
          .linha-nova-flash > td { animation: flashNovaLinha 0.75s ease-in-out 3; }
        `}</style>

        {/* ══ HEADER ════════════════════════════════════════════════════════ */}
        <div
          style={{
            background: '#fff', borderBottom: '1px solid #E5E7EB',
            padding: '16px 28px', display: 'flex', alignItems: 'center',
            justifyContent: 'space-between', flexWrap: 'wrap', gap: 12,
            position: 'sticky', top: 0, zIndex: 100,
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ width: 42, height: 42, borderRadius: 10, background: '#EEF2FF', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <i className="bi bi-file-earmark-text" style={{ fontSize: 19, color: '#4F46E5' }}></i>
            </div>
            <div>
              <h5 style={{ margin: 0, fontWeight: 700, fontSize: 16, color: '#111827' }}>
                {id_pedido > 0 ? `Orçamento #${id_pedido}` : 'Novo Orçamento'}
              </h5>
              <p style={{ margin: 0, fontSize: 12, color: '#6B7280' }}>
                {produtos.length} {produtos.length === 1 ? 'produto' : 'produtos'} ·{' '}
                {totalGeral.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
              </p>
            </div>
          </div>

          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <Link to="/orcamentos" className="btn btn-outline-secondary btn-sm" style={{ fontSize: 13 }}>
              <i className="bi bi-arrow-left me-1"></i>Voltar
            </Link>
            <button className="btn btn-outline-danger btn-sm" style={{ fontSize: 13 }} onClick={() => ImpPdf('Resumo')}>
              <i className="bi bi-file-pdf me-1"></i>Espelho
            </button>
            <button className="btn btn-danger btn-sm" style={{ fontSize: 13 }} onClick={() => ImpPdf('Completo')}>
              <i className="bi bi-printer me-1"></i>Imprimir
            </button>
            <button className="btn btn-success btn-sm" style={{ fontSize: 13 }} onClick={SalvarDados} disabled={loading}>
              {loading
                ? <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                : <i className="bi bi-check2 me-1"></i>}
              Salvar
            </button>
            <CustomButton
              title="Transformar em Pedido"
              color="#7445e1"
              onClick={() => handleExportSale(id_pedido)}
              isLoading={isExportSaleLoading}
              style={{ fontSize: 13 }}
            >
              <ShareFill className="me-1" /> Exportar
            </CustomButton>
          </div>
        </div>

        <div style={{ maxWidth: 1500, margin: '0 auto', padding: '24px 24px 0' }}>

          {/* ══ CARDS RESUMO ═════════════════════════════════════════════════ */}
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: `repeat(${isAdmin ? 4 : 3}, 1fr)`,
              gap: 12, marginBottom: 20,
            }}
          >
            {[
              { label: 'Total de itens',  value: produtos.length,       icon: 'bi-bag',            bg: '#EEF2FF', color: '#4F46E5' },
              { label: 'Qtd total',       value: totalQtd.toFixed(2),   icon: 'bi-stack',          bg: '#ECFDF5', color: '#059669' },
              ...(isAdmin
                ? [{ label: 'Margem estimada', value: `${margem}%`, icon: 'bi-graph-up-arrow', bg: '#FFFBEB', color: '#D97706' }]
                : []),
              {
                label: 'Valor total',
                value: totalGeral.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                icon: 'bi-cash-coin', bg: '#F0FDF4', color: '#16A34A',
              },
            ].map((card) => (
              <div
                key={card.label}
                style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: 12, padding: '14px 18px', display: 'flex', alignItems: 'center', gap: 12 }}
              >
                <div style={{ width: 40, height: 40, borderRadius: 10, background: card.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <i className={`bi ${card.icon}`} style={{ fontSize: 18, color: card.color }}></i>
                </div>
                <div>
                  <p style={{ margin: 0, fontSize: 11, color: '#9CA3AF', fontWeight: 500 }}>{card.label}</p>
                  <p style={{ margin: 0, fontSize: 17, fontWeight: 700, color: '#111827' }}>{card.value}</p>
                </div>
              </div>
            ))}
          </div>

          {/* ══ FORMULÁRIO ═══════════════════════════════════════════════════ */}
          <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: 12, padding: '20px 24px', marginBottom: 20 }}>
            <p style={{ margin: '0 0 16px', fontSize: 11, fontWeight: 700, color: '#9CA3AF', textTransform: 'uppercase', letterSpacing: '.6px' }}>
              <i className="bi bi-info-circle me-1"></i>Dados do orçamento
            </p>

            {/* Linha 1 */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 180px', gap: 14, marginBottom: 14 }}>
              <div>
                <label style={{ fontSize: 12, color: '#6B7280', fontWeight: 600, display: 'block', marginBottom: 5 }}>Cliente</label>
                <div style={{ display: 'flex', gap: 8 }}>
                  <AutocompleteClienteNode
                    placeholder="Pesquisar cliente..."
                    onClickNome={handleNomeCliente} onClickId={handleIdCliente} onClickCpf={handleCpf}
                    value={nomeCliente} className="form-control form-control-sm"
                  />
                  <button className="btn btn-outline-primary btn-sm px-3" onClick={() => setShowModalCliente(true)} title="Cadastrar cliente sem cadastro">
                    <i className="bi bi-person-plus"></i>
                  </button>
                </div>
              </div>
              <div>
                <label style={{ fontSize: 12, color: '#6B7280', fontWeight: 600, display: 'block', marginBottom: 5 }}>Data</label>
                <input type="date" onChange={(e) => setDtPedido(e.target.value)} value={dt_pedido} className="form-control form-control-sm" />
              </div>
            </div>

            {/* Linha 2 */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 14, marginBottom: 14 }}>
              {[
                { label: 'Vendedor',           value: vendedor,       onChange: (e) => setVendedor(e.target.value),       options: vendedores,        placeholder: 'Selecione um vendedor'  },
                { label: 'Indicação de venda', value: indicacaoVenda, onChange: (e) => setIndicacaoVenda(e.target.value), options: parceirosOrdenados, placeholder: 'Selecione um parceiro', id: 'parceiroSelect' },
                { label: 'Prestador',          value: prestador,      onChange: (e) => setPrestador(e.target.value),      options: prestadores,       placeholder: 'Selecione um prestador' },
              ].map((sel) => (
                <div key={sel.label}>
                  <label style={{ fontSize: 12, color: '#6B7280', fontWeight: 600, display: 'block', marginBottom: 5 }}>{sel.label}</label>
                  <select id={sel.id} className="form-control form-control-sm" value={sel.value} onChange={sel.onChange}>
                    <option value="">{sel.placeholder}</option>
                    {sel.options.map((o) => (
                      <option key={o.COD_PESSOA} value={o.COD_PESSOA}>{o.PES_RAZAO}</option>
                    ))}
                  </select>
                </div>
              ))}
            </div>

            {/* Linha 3 */}
            <div style={{ display: 'grid', gridTemplateColumns: '220px 1fr', gap: 14 }}>
              <div>
                <label style={{ fontSize: 12, color: '#6B7280', fontWeight: 600, display: 'block', marginBottom: 5 }}>Desconto em dinheiro</label>
                <CustomPriceInput onChange={(e) => handleDescontoTotal(e.target.value)} value={desconto} className="form-control form-control-sm" />
              </div>
              <div>
                <label style={{ fontSize: 12, color: '#6B7280', fontWeight: 600, display: 'block', marginBottom: 5 }}>Observações gerais</label>
                <textarea className="form-control form-control-sm" rows={1} value={detalhesPedido} onChange={(e) => setDetalhesPedido(e.target.value)} placeholder="Observações do orçamento..." style={{ resize: 'none' }} />
              </div>
            </div>
          </div>

          {/* ══ TOOLBAR ══════════════════════════════════════════════════════ */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10, flexWrap: 'wrap', gap: 8 }}>
            <button type="button" className="btn btn-outline-secondary btn-sm" onClick={alternarModoBusca} style={{ fontSize: 13 }}>
              {estaBuscando
                ? <><i className="bi bi-search me-1"></i>Busca automática</>
                : <><i className="bi bi-pencil me-1"></i>Inserção manual</>}
            </button>
            <span style={{ fontSize: 12, color: '#9CA3AF' }}>
              <i className="bi bi-keyboard me-1"></i>F2 alterna o modo de busca
            </span>
          </div>

          {/* ══ TABELA ═══════════════════════════════════════════════════════ */}
          <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: 12, overflow: 'hidden' }}>

            {loading ? (
              <div style={{ padding: 56, textAlign: 'center' }}>
                <div className="spinner-border text-primary" role="status"></div>
                <p style={{ marginTop: 12, color: '#9CA3AF', fontSize: 14 }}>Carregando produtos...</p>
              </div>
            ) : produtos.length === 0 ? (
              <div style={{ padding: 64, textAlign: 'center' }}>
                <i className="bi bi-box-seam" style={{ fontSize: 44, color: '#D1D5DB', display: 'block', marginBottom: 14 }}></i>
                <p style={{ color: '#6B7280', fontSize: 15, margin: 0, fontWeight: 600 }}>Nenhum produto adicionado</p>
                <p style={{ color: '#9CA3AF', fontSize: 13, margin: '4px 0 0' }}>Clique em "Adicionar produto" abaixo para começar</p>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table mb-0" style={{ fontSize: 12 }}>
                  <thead style={{ background: '#F9FAFB', borderBottom: '1px solid #E5E7EB' }}>
                    <tr>
                      <th style={thStyle}>SKU / Imagem</th>
                      <th style={{ ...thStyle, minWidth: 240 }}>Produto</th>
                      <th style={{ ...thStyle, width: 80, textAlign: 'center' }}>Qtd</th>
                      {isAdmin && <th style={{ ...thStyle, width: 110, textAlign: 'right' }}>Custo unit.</th>}
                      <th style={{ ...thStyle, width: 120, textAlign: 'right' }}>Valor unit.</th>
                      <th style={{ ...thStyle, width: 110, textAlign: 'right' }}>Desconto</th>
                      {isAdmin && <th style={{ ...thStyle, width: 110, textAlign: 'right' }}>Total custo</th>}
                      <th style={{ ...thStyle, width: 130, textAlign: 'right' }}>Total</th>
                      <th style={{ ...thStyle, width: 140 }}>Obs.</th>
                      <th style={{ ...thStyle, width: 46 }}></th>
                    </tr>
                  </thead>

                  <tbody>
                    {produtos.map((produto, index) => {
                      const gkey = norm(produto.grupo_item) || '__SEM__'
                      const isNewGroup =
                        index === 0 ||
                        norm(produto.grupo_item) !== norm(produtos[index - 1]?.grupo_item)
                      const isLastInGroup =
                        index === ultimoIndice ||
                        norm(produto.grupo_item) !== norm(produtos[index + 1]?.grupo_item)

                      return (
                        <LinhaProdutoBloco
                          key={produto.id}
                          produto={produto}
                          index={index}
                          isAdmin={isAdmin}
                          estaBuscando={estaBuscando}
                          isNewGroup={isNewGroup}
                          isLastInGroup={isLastInGroup}
                          ehUltimaLinha={index === ultimoIndice}
                          qtdGrupo={contagemPorGrupo[gkey] || 0}
                          subtotalGrupo={subtotaisPorGrupo[gkey] || 0}
                          isDeleting={isDeleteProductLoading[index]}
                          isNovo={produto.id === novoItemId}
                          onFocado={limparNovoItem}
                          onQtd={onQtd}
                          onVlUnit={onVlUnit}
                          onCusto={onCusto}
                          onDesconto={onDesconto}
                          onObs={onObs}
                          onProdId={onProdId}
                          onProdNome={onProdNome}
                          onProdNomeInput={onProdNomeInput}
                          onProdInterno={onProdInterno}
                          onImg={onImg}
                          onComissao={onComissao}
                          onExcluir={onExcluir}
                          onEditarGrupo={onEditarGrupo}
                          onMoverCima={moverGrupoParaCima}
                          onMoverBaixo={moverGrupoParaBaixo}
                        />
                      )
                    })}
                  </tbody>

                  {/* Total geral */}
                  <tfoot style={{ background: '#F3F4F6', borderTop: '2px solid #E5E7EB' }}>
                    <tr>
                      <td colSpan={isAdmin ? 6 : 4} style={{ padding: '12px 14px', textAlign: 'right', fontWeight: 700, fontSize: 12, color: '#374151' }}>
                        <i className="bi bi-calculator me-1"></i>TOTAL GERAL
                      </td>
                      {isAdmin && (
                        <td style={{ padding: '12px 8px', textAlign: 'right', fontWeight: 700, fontSize: 13, color: '#D97706' }}>
                          {totalCustoAll.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                        </td>
                      )}
                      <td style={{ padding: '12px 8px', textAlign: 'right', fontWeight: 700, fontSize: 16, color: '#16A34A' }}>
                        {totalGeral.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                      </td>
                      <td colSpan={2}></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            )}

            {/* ══ BOTÃO ADICIONAR ══ */}
            <div
              style={{
                padding: '14px 20px',
                borderTop: produtos.length > 0 ? '1px solid #E5E7EB' : 'none',
                background: '#fff', borderRadius: '0 0 12px 12px',
              }}
            >
              <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={AdicionarProduto}
                style={{ fontSize: 13, background: '#4F46E5', borderColor: '#4F46E5' }}
              >
                <i className="bi bi-plus-lg me-1"></i>Adicionar produto
              </button>
            </div>
          </div>

          <div style={{ height: 32 }} />
        </div>
      </div>

      {/* ══ MODAL — selecionar / criar grupo ═══════════════════════════════════ */}
      <Modal show={showGrupoModal} onHide={() => setShowGrupoModal(false)} centered size="md" restoreFocus={false}>
        <div style={{ borderRadius: 16, overflow: 'hidden', background: '#fff', display: 'flex', flexDirection: 'column', maxHeight: '82vh' }}>
          <div style={{ padding: '18px 22px 14px', borderBottom: '1px solid #E5E7EB', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{ width: 36, height: 36, borderRadius: 10, background: '#EEF2FF', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <i className="bi bi-grid" style={{ fontSize: 17, color: '#4F46E5' }}></i>
              </div>
              <div>
                <p style={{ margin: 0, fontSize: 14, fontWeight: 700, color: '#111827' }}>Adicionar produto</p>
                <p style={{ margin: 0, fontSize: 11, color: '#9CA3AF' }}>Selecione o ambiente do projeto</p>
              </div>
            </div>
            <button onClick={() => setShowGrupoModal(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#9CA3AF', padding: 4, borderRadius: 6 }}>
              <i className="bi bi-x-lg" style={{ fontSize: 15 }}></i>
            </button>
          </div>

          <div style={{ padding: '18px 22px', overflowY: 'auto', flex: 1 }}>
            {gruposExistentes.length > 0 ? (
              <>
                <p style={{ margin: '0 0 10px', fontSize: 11, fontWeight: 700, color: '#9CA3AF', textTransform: 'uppercase', letterSpacing: '.6px' }}>
                  Grupos deste orçamento
                </p>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8, marginBottom: 18 }}>
                  {gruposExistentes.map((grupo) => {
                    const sel      = grupoSelecionado === grupo && !novoGrupoInput
                    const qtdItens = contagemPorGrupo[norm(grupo)] || 0
                    return (
                      <button
                        key={grupo} type="button"
                        onClick={() => { setGrupoSelecionado(grupo); setNovoGrupoInput('') }}
                        style={{
                          border: sel ? '2px solid #4F46E5' : '1px solid #E5E7EB',
                          borderRadius: 10, padding: '10px 8px', cursor: 'pointer',
                          textAlign: 'center', background: sel ? '#EEF2FF' : '#F9FAFB',
                          transition: 'all .15s',
                        }}
                      >
                        <i className={`bi ${iconeGrupo(grupo)}`} style={{ fontSize: 22, display: 'block', marginBottom: 5, color: sel ? '#4F46E5' : '#6B7280' }}></i>
                        <p style={{ margin: 0, fontSize: 12, fontWeight: 700, color: sel ? '#3730A3' : '#111827' }}>{grupo}</p>
                        <p style={{ margin: '3px 0 0', fontSize: 10, color: sel ? '#6366F1' : '#9CA3AF' }}>
                          {qtdItens} {qtdItens === 1 ? 'item' : 'itens'}
                        </p>
                      </button>
                    )
                  })}
                </div>
              </>
            ) : (
              <div style={{ textAlign: 'center', padding: '10px 0 20px' }}>
                <i className="bi bi-house-door" style={{ fontSize: 36, color: '#D1D5DB', display: 'block', marginBottom: 10 }}></i>
                <p style={{ fontSize: 14, color: '#6B7280', margin: 0, fontWeight: 600 }}>Nenhum grupo criado ainda</p>
                <p style={{ fontSize: 12, color: '#9CA3AF', margin: '3px 0 0' }}>Crie o primeiro grupo abaixo</p>
              </div>
            )}

            <div style={{ borderTop: gruposExistentes.length > 0 ? '1px solid #E5E7EB' : 'none', paddingTop: gruposExistentes.length > 0 ? 16 : 0 }}>
              <p style={{ margin: '0 0 8px', fontSize: 11, fontWeight: 700, color: '#9CA3AF', textTransform: 'uppercase', letterSpacing: '.6px' }}>
                {gruposExistentes.length > 0 ? 'Ou criar novo grupo' : 'Nome do grupo'}
              </p>
              <div style={{ display: 'flex', gap: 8 }}>
                <input
                  type="text" className="form-control form-control-sm"
                  placeholder="Ex: Banheiro, Varanda, Escritório..."
                  value={novoGrupoInput}
                  autoFocus={gruposExistentes.length === 0}
                  onChange={(e) => { setNovoGrupoInput(e.target.value.toUpperCase()); if (e.target.value) setGrupoSelecionado('') }}
                  onKeyDown={(e) => { if (e.key === 'Enter') confirmarAdicionarProduto() }}
                />
                {novoGrupoInput && (
                  <button type="button" className="btn btn-outline-secondary btn-sm px-3" onClick={() => setNovoGrupoInput('')}>
                    <i className="bi bi-x"></i>
                  </button>
                )}
              </div>
            </div>

            {grupoPreview && (
              <div style={{ marginTop: 14, background: '#EEF2FF', border: '1px solid #C7D2FE', borderRadius: 8, padding: '9px 14px', display: 'flex', alignItems: 'center', gap: 8 }}>
                <i className="bi bi-check-circle-fill" style={{ color: '#4F46E5', fontSize: 15 }}></i>
                <span style={{ fontSize: 13, color: '#3730A3' }}>
                  Produto será adicionado em <strong>{grupoPreview}</strong>
                </span>
              </div>
            )}
          </div>

          <div style={{ padding: '12px 22px 18px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid #E5E7EB', flexShrink: 0, background: '#fff' }}>
            <button type="button" onClick={() => { setGrupoSelecionado(''); setNovoGrupoInput('') }}
              style={{ background: 'none', border: 'none', color: '#9CA3AF', fontSize: 12, cursor: 'pointer', padding: 0 }}>
              <i className="bi bi-eraser me-1"></i>Limpar seleção
            </button>
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="btn btn-outline-secondary btn-sm" onClick={() => setShowGrupoModal(false)} style={{ fontSize: 13 }}>Cancelar</button>
              <button className="btn btn-primary btn-sm" onClick={confirmarAdicionarProduto} style={{ fontSize: 13, background: '#4F46E5', borderColor: '#4F46E5' }}>
                <i className="bi bi-plus-lg me-1"></i>Adicionar produto
              </button>
            </div>
          </div>
        </div>
      </Modal>

      {/* ══ MODAL — editar grupo do item ═══════════════════════════════════════ */}
      <Modal show={itemSelecionado !== null} onHide={() => setItemSelecionado(null)} centered size="sm">
        <div style={{ borderRadius: 16, overflow: 'hidden', background: '#fff', display: 'flex', flexDirection: 'column' }}>
          <div style={{ padding: '16px 20px 12px', borderBottom: '1px solid #E5E7EB', display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 }}>
            <div style={{ width: 32, height: 32, borderRadius: 8, background: '#EEF2FF', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <i className="bi bi-tag" style={{ fontSize: 15, color: '#4F46E5' }}></i>
            </div>
            <p style={{ margin: 0, fontSize: 14, fontWeight: 700, color: '#111827' }}>Editar grupo</p>
          </div>

          <div style={{ padding: '16px 20px', flex: 1 }}>
            {gruposExistentes.length > 0 && (
              <div style={{ marginBottom: 14 }}>
                <p style={{ margin: '0 0 8px', fontSize: 11, fontWeight: 700, color: '#9CA3AF', textTransform: 'uppercase', letterSpacing: '.6px' }}>Grupos existentes</p>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                  {gruposExistentes.map((grupo) => (
                    <button key={grupo} type="button" onClick={() => setInputValue(grupo)}
                      style={{
                        border: inputValue === grupo ? '2px solid #4F46E5' : '1px solid #E5E7EB',
                        borderRadius: 20, padding: '4px 12px', fontSize: 12, cursor: 'pointer',
                        background: inputValue === grupo ? '#EEF2FF' : '#F9FAFB',
                        color: inputValue === grupo ? '#3730A3' : '#374151',
                        fontWeight: inputValue === grupo ? 700 : 400,
                        transition: 'all .12s',
                      }}>
                      <i className={`bi ${iconeGrupo(grupo)} me-1`}></i>{grupo}
                    </button>
                  ))}
                </div>
              </div>
            )}
            <div>
              <label style={{ fontSize: 11, fontWeight: 700, color: '#9CA3AF', textTransform: 'uppercase', letterSpacing: '.6px', display: 'block', marginBottom: 6 }}>
                Grupo atual:{' '}
                <span style={{ color: '#4F46E5', textTransform: 'none' }}>
                  {itemSelecionado !== null ? (produtos[itemSelecionado]?.grupo_item || '—') : ''}
                </span>
              </label>
              <input
                type="text" className="form-control form-control-sm"
                value={inputValue} onChange={handleInputChange}
                placeholder="Nome do grupo..."
                onKeyDown={(e) => { if (e.key === 'Enter') handleInserir() }}
              />
            </div>
          </div>

          <div style={{ padding: '10px 20px 16px', display: 'flex', justifyContent: 'flex-end', gap: 8, borderTop: '1px solid #E5E7EB', flexShrink: 0 }}>
            <button className="btn btn-outline-secondary btn-sm" onClick={() => setItemSelecionado(null)} style={{ fontSize: 13 }}>Cancelar</button>
            <button className="btn btn-primary btn-sm" onClick={handleInserir} style={{ fontSize: 13, background: '#4F46E5', borderColor: '#4F46E5' }}>
              <i className="bi bi-check2 me-1"></i>Salvar
            </button>
          </div>
        </div>
      </Modal>

      {showModalCliente && (
        <ModalIncluirCliente
          onSaveCliente={({ cpf, nome }) => { setCpf(cpf); setNomeCliente(nome); setSemCad(true); setShowModalCliente(false) }}
          onCancel={() => setShowModalCliente(false)}
        />
      )}
    </>
  )
}

export default OrcamentoEditar